import request from '@/utils/request'

let RegionagentApi = {

    /*代理列表*/
    getList(data) {
        return request._post('/shop/plus.datashare.shop/index', data);
    },

    /*添加数据互通*/
    add(data) {
        return request._post('/shop/plus.datashare.shop/add', data);
    },
    /*修改数据互通*/
    edit(data) {
        return request._post('/shop/plus.datashare.shop/edit', data);
    },
    /*删除数据互通*/
    del(data) {
        return request._post('/shop/plus.datashare.shop/del', data);
    },
    /*数据互通详情*/
    detail(data) {
    return request._post('/shop/plus.datashare.shop/detail', data);
    },


    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.datashare.shop/setting', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.datashare.shop/setting', data);
    },
    /*复制*/
    copy(data) {
        return request._post('/shop/plus.datashare.shop/copy', data);
    },


}

export default RegionagentApi;



// WEBPACK FOOTER //
// ./src/api/datashare.js